import { Stack, Switch, Typography, useTheme } from "@mui/material";
import { useAtom } from "jotai";
import { toast } from "sonner";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CollapsibleSection } from "web_myplann/Shared/Components/CollapsibleSection";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";
import { userState } from "web_myplann/Shared/State/UserAtom";
import { device } from "web_myplann/Utils/device";

export const SecurityPage = () => {
	const theme = useTheme();
	const { t } = useResource();
	const [userAtom, setUserAtom] = useAtom(userState);

	const handleChangeHasBiometry = async () => {
		if (window.ReactNativeWebView) {
			const newHasBiometry = !userAtom.hasBiometry;
			const result = await device.changeBiometryStatus(newHasBiometry);

			if (result.payload.success) {
				setUserAtom({ ...userAtom, hasBiometry: newHasBiometry });
			} else {
				toast.error(
					result.payload.error ?? t(Resources.Security.BiometryError),
				);
			}
		}
	};

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.grey[100]}
			topBar={
				<NavigationHeader
					title={t(Resources.Security.title)}
					defaultRoute={Routing.Profile.More.path()}
				/>
			}
		>
			<Stack sx={{ minHeight: "100%" }}>
				<CollapsibleSection title={t(Resources.Security.Sections.Login)}>
					<Stack sx={{ bgcolor: theme.palette.background.paper }}>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="space-between"
							px={1.6}
							py={1.2}
							minHeight={48}
						>
							<Typography variant="body1" color={theme.palette.grey[700]}>
								{t(Resources.Security.Biometry)}
							</Typography>
							<Switch
								checked={userAtom.hasBiometry}
								onChange={handleChangeHasBiometry}
							/>
						</Stack>
					</Stack>
				</CollapsibleSection>
			</Stack>
		</MyPlannLayout>
	);
};
